const issueStatus = {
    open: {
        value: 0,
        i18nKey: "_enums.issueStatus.open",
        class: "green--text"
    },
    pending: {
        value: 1,
        i18nKey: "_enums.issueStatus.pending",
        class: "orange--text"
    },
    closed: {
        value: 2,
        i18nKey: "_enums.issueStatus.closed",
        class: "blue--text"
    },
}

export const Enums = {
    issueStatus
};